var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// 入力履歴
import React, { useState, useEffect, useCallback } from 'react';
import { render } from 'react-dom';
import axios from '../axios';
import DatePicker from '../organisms/DatePicker';
import Moment from 'moment';
import { handleBrowzerBack } from '../BrowzerBack';
import HistoryResultList from '../organisms/HistoryResultList';
import LoadingModal from '../organisms/LoadingModal';
import { jumpUrl } from '../Common';
import { Button } from 'react-bootstrap';
import { header_info_init, reception_history_search_params_init } from '../Const';
import { Form, InputGroup } from 'react-bootstrap';
var ReceptionHistory = function (_a) {
    var r_cd = _a.r_cd;
    var _b = useState([]), receptions = _b[0], setReceptions = _b[1];
    var _c = useState(), update_status_list = _c[0], setUpdateStatusList = _c[1];
    var _d = useState(), uesr_update_type_list = _d[0], setUserUpdateTypeList = _d[1];
    // Ajax通信中フラグ
    var _e = useState(false), is_connecting = _e[0], setIsConnecting = _e[1];
    // 検索パラメータの初期化
    var _f = useState(reception_history_search_params_init), search_params = _f[0], setSearchParams = _f[1];
    var _g = useState(false), is_loading = _g[0], setIsLoading = _g[1];
    //案件履歴ヘッダー情報
    var _h = useState(header_info_init), reception_history_header = _h[0], setReceptionHistoryHeader = _h[1];
    // 行選択の状態管理
    var _j = useState({}), row_selection = _j[0], setRowSelection = _j[1];
    // 検索ボタン押下
    var handleClickSearch = useCallback(function () {
        // クリックイベント
        var searchReceptionHistory = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, newReceptions, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        //ローディング画面表示
                        setIsLoading(true);
                        if (is_connecting) {
                            return [2 /*return*/];
                        }
                        setIsConnecting(true);
                        return [4 /*yield*/, axios.post("staff/api/history/search/" + r_cd, search_params)];
                    case 1:
                        response = _a.sent();
                        newReceptions = response.data.reception_history_list;
                        setReceptions(newReceptions);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1.response.data.message);
                        jumpUrl(error_1.response.data.url);
                        setIsConnecting(false);
                        return [3 /*break*/, 4];
                    case 3:
                        //ローディング画面非表示
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        searchReceptionHistory();
    }, [search_params, is_connecting]);
    // 検索パラメータを設定
    var handleChangeSearchParams = function (target, param) {
        var key = target; // targetの型を明示的に指定
        var setParam = typeof param === 'string' ? '' : [];
        var params = Object.assign({}, search_params);
        if (Object.prototype.toString.call(param).slice(8, -1).toLowerCase() === 'date') {
            // Date型
            setParam = Moment(param).format('YYYY-MM-DD');
        }
        else if (typeof param === 'string') {
            // string型
            setParam = param;
        }
        else if (typeof param === 'object') {
            // object型
            // 更新者種別リストと照合してリクエストに必要なデータを生成する
            var uesr_update_type_details_1 = [];
            Object.keys(row_selection).map(function (key) {
                if (row_selection[key]) {
                    // 更新者種別リストと照合する
                    uesr_update_type_list === null || uesr_update_type_list === void 0 ? void 0 : uesr_update_type_list.map(function (uesr_update_type) {
                        var uesr_update_type_key = uesr_update_type['key'].toString();
                        if (uesr_update_type_key === key) {
                            uesr_update_type_details_1.push(uesr_update_type);
                        }
                    });
                }
            });
            setParam = uesr_update_type_details_1;
        }
        params[key] = setParam;
        setSearchParams(params);
    };
    /**
     * チェックボックスのcheckedを操作する
     * @param index 案件ID
     */
    var rowSelection = useCallback(function (event) {
        var index = event === null || event === void 0 ? void 0 : event.target.value;
        var new_row_selection = row_selection;
        var keys = Object.keys(row_selection);
        if (keys.length === 0) {
            new_row_selection[index] = true;
        }
        else {
            if (keys.includes(index)) {
                new_row_selection[index] = !new_row_selection[index];
            }
            else {
                new_row_selection[index] = true;
            }
        }
        handleChangeSearchParams('update_user_type', new_row_selection);
    }, [row_selection, uesr_update_type_list, search_params]);
    // 画面初期表示
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        var getReception = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get("staff/api/history/init/" + r_cd)];
                    case 1:
                        response = _a.sent();
                        setReceptions(response.data.reception_history_list);
                        setUpdateStatusList(response.data.update_status_list);
                        setUserUpdateTypeList(response.data.user_update_type_list);
                        setReceptionHistoryHeader(response.data.reception_history_header);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getReception();
    }, []);
    var handleClickClear = function () {
        var new_search_param = reception_history_search_params_init;
        setSearchParams(new_search_param);
        setRowSelection({});
    };
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "reception-history-search-form" },
            React.createElement("div", { className: "row my-2" },
                React.createElement("div", { className: "col-md-4 col-sm-12" },
                    React.createElement("span", { className: "search-criteria-head" }, "\u66F4\u65B0\u65E5"),
                    React.createElement(DatePicker, { id: "search-update-from", className: "search-update-at", handleChangeDate: function (date) { return handleChangeSearchParams('from_update_at', date); }, selected: search_params.from_update_at.length > 0
                            ? new Date(search_params.from_update_at)
                            : null, customInput: React.createElement("input", { type: "text", className: "search-form-input" }) }),
                    "\uFF5E",
                    React.createElement(DatePicker, { id: "search-update-to", className: "search-update-at", handleChangeDate: function (date) { return handleChangeSearchParams('to_update_at', date); }, selected: search_params.to_update_at.length > 0 ? new Date(search_params.to_update_at) : null, customInput: React.createElement("input", { type: "text", className: "search-form-input" }) })),
                React.createElement("div", { className: "col-md-3 col-sm-12" },
                    React.createElement("span", { className: "search-criteria-head" }, "\u66F4\u65B0\u9805\u76EE"),
                    React.createElement("input", { type: "text", className: "search-form-item-name", name: "\u66F4\u65B0\u9805\u76EE", value: search_params.item_name, onChange: function (event) {
                            return handleChangeSearchParams('item_name', event === null || event === void 0 ? void 0 : event.target.value);
                        } }))),
            React.createElement("div", { className: "row my-2" },
                React.createElement("div", { className: "col-md-4 col-sm-12" },
                    React.createElement("span", { className: "search-criteria-head" }, "\u66F4\u65B0\u8005\u7A2E\u5225"),
                    React.createElement(InputGroup, null, uesr_update_type_list === null || uesr_update_type_list === void 0 ? void 0 : uesr_update_type_list.map(function (src) {
                        return (React.createElement("label", { className: "check-box-label", key: src.key },
                            React.createElement(Form.Check, { disabled: false, id: 'test', type: "checkbox", inline: true, value: src.key, name: 'name', onChange: rowSelection, className: "check-box", checked: row_selection[src.key] !== undefined && row_selection[src.key] !== null
                                    ? row_selection[src.key]
                                    : false }),
                            src.value));
                    }))),
                React.createElement("div", { className: "col-md-3 col-sm-12" },
                    React.createElement("span", { className: "search-criteria-head" }, "\u66F4\u65B0\u8005"),
                    React.createElement("input", { type: "text", className: "search-form-update-name", name: "\u66F4\u65B0\u8005", value: search_params.update_name, onChange: function (event) {
                            return handleChangeSearchParams('update_name', event === null || event === void 0 ? void 0 : event.target.value);
                        } })),
                React.createElement("div", { className: "col-md-3 col-sm-12" },
                    React.createElement("span", { className: "search-criteria-head" }, "\u66F4\u65B0\u6642\u72B6\u614B"),
                    React.createElement("select", { value: search_params.status, className: "search-form-status", onChange: function (event) {
                            return handleChangeSearchParams('status', event === null || event === void 0 ? void 0 : event.target.value);
                        } },
                        React.createElement("option", null), update_status_list === null || update_status_list === void 0 ? void 0 :
                        update_status_list.map(function (option, index) {
                            return (React.createElement("option", { key: index, value: option.key },
                                option.key,
                                "\uFF1A",
                                option.value));
                        }))),
                React.createElement("div", { className: "col-md-auto text-right" },
                    React.createElement(Button, { variant: "main-color", className: "btn-clear", onClick: handleClickClear }, "\u30AF\u30EA\u30A2"),
                    React.createElement("button", { id: "search-btn", className: "btn btn-main-color", onClick: function () { return handleClickSearch(); } }, "\u691C \u7D22")))),
        React.createElement(HistoryResultList, { data: receptions }),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('reception-history')) {
    // Bladeから案件IDを取得する
    var r_cd = document.getElementById('reception-history').getAttribute('r_cd');
    render(React.createElement(ReceptionHistory, { r_cd: r_cd }), document.getElementById('reception-history'));
}
